import 'leaflet/dist/leaflet.css';

import L from 'leaflet';

export const  getCoords =  (pan)=>{
	if (!pan){
		return {coords: [45, 9], zoom:5}
	}
	let s = pan.split('|')
	return {
		coords: [
			parseFloat(s[0] || '45'),
			parseFloat(s[1] || '9')
			],
		zoom: parseInt(s[2] || '5')
	}
}

let icon1 = (color, stroke)=>`<svg fill="${color}" height="32px" width="32px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
viewBox="0 0 297 297" xml:space="preserve">
<path stroke="${stroke}" stroke-width="20" d="M148.5,0C85.646,0,34.511,51.136,34.511,113.989c0,25.11,8.008,48.926,23.157,68.873
c13.604,17.914,32.512,31.588,53.658,38.904l27.464,68.659c1.589,3.971,5.434,6.574,9.71,6.574c4.276,0,8.121-2.603,9.71-6.574
l27.464-68.659c21.146-7.316,40.054-20.99,53.658-38.904c15.149-19.947,23.157-43.763,23.157-68.873
C262.489,51.136,211.354,0,148.5,0z M148.5,72.682c22.777,0,41.308,18.53,41.308,41.308c0,22.777-18.53,41.309-41.308,41.309
c-22.777,0-41.308-18.531-41.308-41.309C107.192,91.212,125.723,72.682,148.5,72.682z"/>
</svg>`;


export const getMarkerIcon = (marker, active, conf)=>{
	let iconName = marker.icon || (conf.icon || 'svg-icon-pin');
	const icon = `<svg  style="width:100%;height:100%"><use xlink:href="/wp-content/webfactory/icons.svg#${iconName.replace('svg-icon-', '')}"></use></svg>`
	let iconSize = (conf?.markerSize)?conf.markerSize: [];
	iconSize = [
		iconSize[0] ? iconSize[0] : 24,
		iconSize[1] ? iconSize[1] : 24
		]

	return L.divIcon({
		className: 'custom-svg-icon', 
		html: icon,
		iconSize: iconSize
	})
}

export const nl2brInline = (text) => {
	if (!text){
		return null
	}
	const newText = text.split('\n').join('<br>')
	return newText;
};

export const nl2br = (text) => {
	if (!text){
		return null
	}
	const newText = text.split('\n').map((str, index) => (
		<React.Fragment key={index}>
		{str}
      {index !== text.length - 1 && <br />} {/* Add <br> except for the last line */}
		</React.Fragment>
		));
	return newText;
};

export const uniqId = (length, col) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let uniqueId = '';

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    uniqueId += characters.charAt(randomIndex);
  }
  if (col && col.includes(uniqueId)){
  	return uniqId(length, col);
  }

  return uniqueId;
}